import { TransactionReports } from "../../common/transaction-reports/transaction-reports";

export function BackofficeTransactionReports() {
  return <TransactionReports />;
}
